(() => {
  const EXPIRY_KEY = "sd_cart_expiry_ts";
  const EXPIRY_SECONDS = 10 * 60; // 10 minutes

  const pad = (n) => String(n).padStart(2, "0");

  function getOrSetExpiry() {
    const now = Date.now();
    const existing = Number(localStorage.getItem(EXPIRY_KEY) || 0);

    if (!existing || existing < now) {
      const next = now + EXPIRY_SECONDS * 1000;
      localStorage.setItem(EXPIRY_KEY, String(next));
      return next;
    }
    return existing;
  }

  function stopTimer(bannerEl) {
    if (!bannerEl) return;
    const id = bannerEl._expiryIntervalId;
    if (id) clearInterval(id);
    bannerEl._expiryIntervalId = null;
  }

  function startTimerForBanner(bannerEl) {
    if (!bannerEl) return;

    // If banner got re-rendered, make sure we don’t stack intervals
    stopTimer(bannerEl);

    const timeEl = bannerEl.querySelector("[data-cart-expiry-time]");
    if (!timeEl) return;

    bannerEl.hidden = false;

    let expiry = getOrSetExpiry();

    const tick = () => {
      const ms = expiry - Date.now();
      const totalSec = Math.max(0, Math.floor(ms / 1000));
      const m = Math.floor(totalSec / 60);
      const s = totalSec % 60;

      timeEl.textContent = `${m}:${pad(s)}`;

      if (totalSec <= 0) {
        expiry = getOrSetExpiry(); // restart once it hits 0
      }
    };

    tick();
    bannerEl._expiryIntervalId = setInterval(tick, 1000);
  }

  function initExpiryBanner() {
    // Scope to the latest banner in the DOM (important for drawers)
    const banner = document.querySelector("[data-cart-expiry-banner]");
    if (!banner) return;
    startTimerForBanner(banner);
  }

  // Run once on page load
  document.addEventListener("DOMContentLoaded", () => {
    initExpiryBanner();
  });

  // Run after cart updates (drawer re-render)
  document.addEventListener("cart:updated", () => {
    initExpiryBanner();
  });

  // Extra safety: if your theme replaces the drawer without firing cart:updated
  const observer = new MutationObserver(() => {
    const banner = document.querySelector("[data-cart-expiry-banner]");
    if (banner && !banner._expiryIntervalId) {
      // only start if not already running on this element
      startTimerForBanner(banner);
    }
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
})();


(() => {
  /* ---------------------------
     INSURANCE TOGGLE (FAST + RELIABLE)
  ---------------------------- */

  async function getCart() {
    const r = await fetch("/cart.js", { credentials: "same-origin" });
    if (!r.ok) throw new Error("Failed to read cart");
    return r.json();
  }

  async function cartAdd(variantId) {
    const r = await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      credentials: "same-origin",
      body: JSON.stringify({ id: Number(variantId), quantity: 1 }),
    });
    if (!r.ok) throw new Error("Failed to add insurance");
    return r.json();
  }

  async function cartChangeByKey(lineItemKey, quantity) {
    const r = await fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      credentials: "same-origin",
      body: JSON.stringify({ id: lineItemKey, quantity }),
    });
    if (!r.ok) throw new Error("Failed to change insurance");
    return r.json();
  }

  async function removeInsuranceVariant(variantId) {
    const cart = await getCart();
    const item = cart.items.find((i) => String(i.variant_id) === String(variantId));
    if (!item) return; // already not in cart
    return cartChangeByKey(item.key, 0);
  }

  // BEST-EFFORT: ask theme to re-render the drawer
  function notifyCartUpdated() {
    document.dispatchEvent(new CustomEvent("cart:updated"));
    document.dispatchEvent(new CustomEvent("cart:refresh"));
    // Some themes listen to this:
    document.dispatchEvent(new CustomEvent("theme:cart:updated"));
  }

  function setToggleUI(btn, isOn) {
    btn.setAttribute("aria-checked", isOn ? "true" : "false");
    btn.classList.toggle("is-on", isOn); // if you add the .is-on CSS I sent
  }

  // Event delegation so it works even after drawer re-renders
  document.addEventListener("click", async (e) => {
    const btn = e.target.closest("[data-cart-insurance-toggle]");
    if (!btn) return;

    const wrap = btn.closest("[data-cart-insurance]");
    if (!wrap) return;

    const variantId = wrap.getAttribute("data-variant-id");
    if (!variantId) return;

    // Prevent double-click while request is running
    if (btn.dataset.loading === "1") return;
    btn.dataset.loading = "1";

    // ✅ Optimistic UI: toggle instantly
    const nextState = btn.getAttribute("aria-checked") !== "true";
    setToggleUI(btn, nextState);

    try {
      if (nextState) {
        await cartAdd(variantId);
      } else {
        await removeInsuranceVariant(variantId);
      }

      // ✅ tell theme to re-render
      notifyCartUpdated();
    } catch (err) {
      console.error(err);
      // revert UI if failed
      setToggleUI(btn, !nextState);
    } finally {
      btn.dataset.loading = "0";
    }
  });

  // Optional: sync UI when drawer opens/re-renders
  async function syncInsuranceUI() {
    const wrap = document.querySelector("[data-cart-insurance]");
    if (!wrap) return;

    const variantId = wrap.getAttribute("data-variant-id");
    const btn = wrap.querySelector("[data-cart-insurance-toggle]");
    if (!variantId || !btn) return;

    try {
      const cart = await getCart();
      const hasInsurance = cart.items.some((i) => String(i.variant_id) === String(variantId));
      setToggleUI(btn, hasInsurance);
    } catch (e) {}
  }

  document.addEventListener("DOMContentLoaded", syncInsuranceUI);
  document.addEventListener("cart:updated", syncInsuranceUI);
})();

